import Vue from 'vue';

import { TrialFeatures } from 'client/util/Constants/FeatureTrialConstants';

import AuthNPoliciesApi from 'client/api/v2/AuthNPoliciesApi';
import CollectionModule from 'client/store/modules/CollectionModule';

const initialFiltersState = () => [];

const refreshTrialData = (context = {}) => {
  context.dispatch('FeatureTrialModule/fetchFeatureUsage', { featureCode: TrialFeatures.zeroTrust.code }, { root: true });
};

export class AuthNPoliciesCollectionClass extends CollectionModule {
  getInitialState() {
    const state = super.getInitialState();
    state.features.items.filters = initialFiltersState();
    return state;
  }

  RESET_COLLECTION(state, payload) {
    if (typeof state === 'undefined') return; // For tests where state has not been initialized
    super.RESET_COLLECTION(state, payload);
    Vue.set(state.features.items, 'filters', initialFiltersState());
  }

  deleteItems(context, ids = []) {
    const deletePromise = super.deleteItems(context, ids);
    deletePromise.then(() => {
      refreshTrialData(context);
    });
    return deletePromise;
  }

  refreshCollection(
    context = {},
    {
      item,
      skip = context.state.features.items.pagination.skip || '',
      forceRefresh = false,
    } = {},
  ) {
    super.refreshCollection(context, { item, skip, forceRefresh }).then(() => {
      refreshTrialData(context);
    });
  }
}

export default new AuthNPoliciesCollectionClass(AuthNPoliciesApi, 'id').extractModule();
